import React from 'react';
import LoginStatus from './LoginStatus';
import './Status.css';

const Status = () => {
  return (
    <div className="status-container">
      <div className="page-header mb-4">
        <div>
          <h2 className="page-title">Status</h2>
          <p className="page-subtitle text-muted">Monitoreo de servicios y rendimiento</p>
        </div>
      </div>

      <LoginStatus />
    </div>
  );
};

export default Status;
